import { SET_BULK_PARAMS_SONG, CLEAR_PARAMS_SONG, SET_PARAMS_SONG } from "constants/types";

const initialState = {
    search: "",
    page: 1,
    size: 10,
    composer_id: "",
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case SET_PARAMS_SONG:
            return {
                ...state,
                [payload.key]: payload.value,
            };
        case SET_BULK_PARAMS_SONG:
            return {
                ...state,
                ...payload, // Make sure payload contains valid keys like `search` or `page`
            };
        case CLEAR_PARAMS_SONG:
            return {
                ...state,
                search: "",
                page: 1,
            };
        default:
            return state;
    }
}
